<style scoped lang="scss">
@import "@/sass/theme.scss";
</style>

<template>
  <div :class="`app-inner${wakeLockEnabled ? ' no-cursor' : ''}`"  @mouseup="wakeLockEnabled ? fullScreen() : null" >
    <div v-show="!wakeLockEnabled" class="options-wrapper">
      <div
        v-if="!clock_mode"
        class="input-wrapper"
        @click.stop="(expandwidth === '0') ? expandwidth = '33' : false; (expandwidth === '33') ? $refs.changetext.focus() : false"
        :style="(expandwidth === '0') ? 'cursor: pointer;': 'pointer-event: none;'"
      >
        <i class="fas fa-edit"></i>
        <input
          ref="changetext"
          type="text"
          :class="(expandwidth === '33') ? 'active' : false"
          :style="(expandwidth === '0') ? `cursor: pointer; min-width:${expandwidth}vw`: `min-width:${expandwidth}vw`"
          v-model="user_string"
          @change="createString()"
          @blur="(expandwidth === '33') ? expandwidth = '0' : false"
        />
        <div :class=" (expandwidth === '33') ? 'delete-string active' : `delete-string`" @mousedown="user_string = ``; createString()"> 
          <i class="fas fa-backspace"></i>
        </div>
       
      </div>

      <div class="color-select-wrap">
        <input
          class="color-select"
          type="color"
          v-model="circleStyle.fillStyle"
          @change="createString()"
        />
      </div>

      <button class="copy-link" @click.stop.prevent="copyLink">
        <i class="fas fa-link"></i>
      </button>
      <input type="hidden" id="testing-code" :value="queryoparams" />

      <button class="fullscreen-btn" @click="fullScreen()">
        <i class="fas fa-expand"></i>
      </button>

      <button :class="`clock${clock_mode ? ' clock-active' : ''}`" @click="clock_mode_switch()">
        <i class="fas fa-clock"></i>
      </button>
    </div>

    <canvas id="c" :class="`${wakeLockEnabled ? 'fullscreen' : ''}`"></canvas>

    <div v-if="!wakeLockEnabled" class="screen-rotate-info">
      <i class="fas fa-mobile-alt rotating"></i>
      <span>Please turn your device</span>
    </div>
  </div>
</template>

<script>
// const facebook = () => import("@/components/facebook.vue");
// const moment = require("moment"); // require
const localforage = require("localforage");
const Notify = require("notifyjs");
// import { Howl } from "howler";
import NoSleep from "nosleep.js";
import alphabet_json from "@/js/alphabet.json";

import "@/js/event-bus.js";

const requestInterval = require("request-interval");

// moment().format();

var store = localforage.createInstance({
  name: "led-multi"
});

export default {
  name: "ledmulti",
  components: {
    // facebook
  },
  props: {
    msg: String
  },
  data() {
    return {
      expandwidth: "0",
      clock_mode: false,
      time: undefined,
      running_animation: undefined,
      offset: 0,
      canvas: undefined,
      ctx: undefined,
      offscreen_canvas: undefined,
      offscreen_ctx: undefined,
      circleStyle: {
        radius: undefined,
        fillStyle: "#ff0000",
        lineWidth: 3,
        strokeStyle: "#330000"
      },
      circleStyle_off: {
        radius: undefined,
        fillStyle: "rgba(0, 0, 0, 0.96)",
        lineWidth: 0,
        strokeStyle: "rgba(0, 0, 0, 0.96)"
      },
      ledoffset: `transform: translateX(0px);`,
      alphabet: alphabet_json,
      showMainWrapper: false,
      doNotification_blocked: false,
      doNotification: false,
      blockSize: 0,
      blocks: [],
      blocks_time: [],
      blocks_for_render: [],
      horizontalLines: 0,
      user_string: "welcome to ledmulti... click the icons to change the text, colours, create a link, go fullscreen/turn off screen sleep and switch to clock mode.  ",
      //"abcdefghijklmnopqrstuvwxyz 1234567890 :;@',.   "
      queryoparams: "",
      wakeLockEnabled: false
    };
  },
  watch: {
    // user_string: function(val) {
    //   store.setItem("last_message_user_string", val);
    //   window.history.replaceState({}, document.title, "/");
    // },
    // circleStyle: function(val) {
    //   console.log(val);
    //   store.setItem("last_message_color", val.fillStyle);
    //   window.history.replaceState({}, document.title, "/");
    // }
  },
  mounted() {
    //this.restartSettings();

    let canvas = document.getElementById("c");
    let ctx = canvas.getContext("2d");
    this.canvas = canvas;
    this.ctx = ctx;

    //this.getNotificationPermissions();
    this.worker = new Worker("js/webworker_interval.js");
    // this.sound_clock = new Howl({
    //   src: "sounds/Clock_ticking.mp3",
    //   volume: 0.3,
    //   loop: true
    // });

    // startup
    let vm = this;
    window.eventBus.listen("show-app", () => {
      setTimeout(() => {
        vm.showMainWrapper = window.eventBus.get("show-app");
      }, 0);
    });

    this.getBlockSize();
    this.noSleep = new NoSleep();
  },
  computed: {},
  methods: {
    getTime() {
      let d = new Date();
      let hour = `0${d.getHours()}`.slice(-2);
      let mins = `0${d.getMinutes()}`.slice(-2);
      return `${hour}:${mins}`;
    },

    clock_mode_switch() {
      this.clock_mode = !this.clock_mode;
      this.createOffScreenCanvas();
      this.startTimer();
      if (this.clock_mode) {
        this.create_clock_canvas(this.getTime());
        store.setItem("clock_mode", true);
      } else {
        store.setItem("clock_mode", false);
      }
      this.createString();
    },

    create_clock_canvas(newtime) {
      this.blocks_time = [];
      this.time = newtime;
      let timeStringArray = newtime.split("");

      for (let val in timeStringArray) {
        for (let gap in this.alphabet.gap) {
          this.blocks_time.push(this.alphabet.gap[gap]);
        }

        let num = timeStringArray[val].toString();
        let letter = JSON.parse(JSON.stringify(this.alphabet[num]));

        for (let line in letter.reverse()) {
          for (let div in letter[line]) {
            this.blocks_time.push(letter[line][div]);
          }
        }
      }

      for (let gap in this.alphabet.gap) {
        this.blocks_time.push(this.alphabet.gap[gap]);
      }

      this.createOffScreenCanvas();
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(this.offscreen_canvas, 0, 0);
    },

    drawCanvas_clock() {
      if (this.time !== this.getTime()) {
        this.create_clock_canvas(this.getTime());
      }
    },

    drawCanvas(Xoffset) {
      if (!Xoffset) {
        Xoffset = 0;
      }
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(this.offscreen_canvas, Xoffset, 0);
      this.ctx.drawImage(
        this.offscreen_canvas,
        Xoffset + this.offscreen_canvas.width,
        0
      );
    },
    drawCircle(x_offset, y_offset) {
      let x = x_offset + this.circleStyle.radius;
      let y = y_offset + this.circleStyle.radius;
      this.offscreen_ctx.beginPath();
      this.offscreen_ctx.arc(
        x,
        y,
        this.circleStyle.radius - 2,
        0,
        2 * Math.PI,
        false
      );
      this.offscreen_ctx.fillStyle = this.circleStyle.fillStyle;
      this.offscreen_ctx.fill();
    },
    drawCircle_off(x_offset, y_offset) {
      let x = x_offset + this.circleStyle_off.radius;
      let y = y_offset + this.circleStyle_off.radius;

      this.offscreen_ctx.beginPath();

      this.offscreen_ctx.arc(
        x,
        y,
        this.circleStyle_off.radius - 3,
        0,
        2 * Math.PI,
        false
      );

      this.offscreen_ctx.fillStyle = this.circleStyle.fillStyle;
      this.offscreen_ctx.fill();

      this.offscreen_ctx.arc(
        x,
        y,
        this.circleStyle_off.radius - 2,
        0,
        2 * Math.PI,
        false
      );

      this.offscreen_ctx.fillStyle = this.circleStyle_off.fillStyle;
      this.offscreen_ctx.fill();
    },
    createOffScreenCanvas() {
      this.offscreen_canvas = document.createElement("canvas");
      if (!this.clock_mode) {
        this.offscreen_canvas.width = this.blockSize * (this.blocks.length / 7);
      } else {
        this.offscreen_canvas.width =
          this.blockSize * (this.blocks_time.length / 7);
      }
      this.offscreen_canvas.height = this.blockSize * 7;
      this.offscreen_ctx = this.offscreen_canvas.getContext("2d");

      this.circleStyle.radius = this.blockSize / 2;
      this.circleStyle_off.radius = this.blockSize / 2;

      let moveX = 0;
      let moveY = 0;

      let rad = this.circleStyle.radius;
      let blockCol = 0;
      let blockRow = 0;

      this.offscreen_ctx.clearRect(
        0,
        0,
        this.offscreen_canvas.width,
        this.offscreen_canvas.height
      );

      if (!this.clock_mode) {
        for (let block in this.blocks) {
          if (this.blocks[block] === 1) {
            this.drawCircle(moveX + rad * blockCol, moveY + rad * blockRow);
          } else {
            this.drawCircle_off(moveX + rad * blockCol, moveY + rad * blockRow);
          }
          if (blockRow === 12) {
            blockRow = 0;
            blockCol += 2;
          } else {
            blockRow += 2;
          }
        }
      } else {
        for (let block in this.blocks_time) {
          if (this.blocks_time[block] === 1) {
            this.drawCircle(moveX + rad * blockCol, moveY + rad * blockRow);
          } else {
            this.drawCircle_off(moveX + rad * blockCol, moveY + rad * blockRow);
          }

          if (blockRow === 12) {
            blockRow = 0;
            blockCol += 2;
          } else {
            blockRow += 2;
          }
        }
      }
    },

    createString() {
      let vm = this;
      store.setItem("last_message_user_string", vm.user_string);
      store.setItem("last_message_color", vm.circleStyle.fillStyle);
      console.log(vm.circleStyle.fillStyle);

      this.blocks = [];
      let splitString;

      if (this.user_string.length < 1) {
        splitString = [" ", " ", " ", " ", " ", " ", " "];
      } else if (this.user_string.length < 2) {
        splitString = [
          this.user_string.split("")[0],
          " ",
          " ",
          " ",
          " ",
          " ",
          " "
        ];
      } else if (this.user_string.length < 3) {
        splitString = [
          this.user_string.split("")[0],
          this.user_string.split("")[1],
          " ",
          " ",
          " ",
          " ",
          " "
        ];
      } else if (this.user_string.length < 4) {
        splitString = [
          this.user_string.split("")[0],
          this.user_string.split("")[1],
          this.user_string.split("")[2],
          " ",
          " ",
          " ",
          " "
        ];
      } else if (this.user_string.length < 5) {
        splitString = [
          this.user_string.split("")[0],
          this.user_string.split("")[1],
          this.user_string.split("")[2],
          this.user_string.split("")[3],
          " ",
          " ",
          " "
        ];
      } else if (this.user_string.length < 6) {
        splitString = [
          this.user_string.split("")[0],
          this.user_string.split("")[1],
          this.user_string.split("")[2],
          this.user_string.split("")[3],
          this.user_string.split("")[4],
          " ",
          " "
        ];
      } else if (this.user_string.length < 7) {
        splitString = [
          this.user_string.split("")[0],
          this.user_string.split("")[1],
          this.user_string.split("")[2],
          this.user_string.split("")[3],
          this.user_string.split("")[4],
          this.user_string.split("")[5],
          " "
        ];
      } else {
        splitString = this.user_string.split("");
      }

      for (let char in splitString) {
        let thischar = splitString[char].toLowerCase();
        if (thischar === " ") {
          this.addLetter("space");
        } else {
          this.addLetter(thischar);
        }
      }

      let domain = window.location.href.split("?")[0].toString();
      this.queryoparams = `${domain}?color=${this.circleStyle.fillStyle}&clock_mode=${this.clock_mode}&text="${this.user_string}"`;

      this.createOffScreenCanvas();
      this.startTimer();
      if (this.clock_mode) {
        this.create_clock_canvas(this.getTime());
      }
    },
    addLetter(val) {
      if (!this.alphabet[val]) {
        return false;
      }

      for (let gap in this.alphabet.gap) {
        this.blocks.push(this.alphabet.gap[gap]);
      }
      let letter = JSON.parse(JSON.stringify(this.alphabet[val]));
      for (let line in letter.reverse()) {
        for (let div in letter[line]) {
          this.blocks.push(letter[line][div]);
        }
      }
    },
    getBlockSize() {
      let vm = this;
      // let height;
      let width;
      window.onload = function() {
        setTimeout(viewportSize, 1);
      };
      window.onresize = function() {
        viewportSize();
      };
      function viewportSize() {
        width = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        setBlockSize();
      }
      function setBlockSize() {
        vm.blockSize = Math.floor(window.innerWidth / 27);
        let blockstyles = document.getElementById("js-styles");
        blockstyles.innerHTML = `.led-inner>div{width:${vm.blockSize}px; height:${vm.blockSize}px;}`;
        vm.horizontalLines = Math.floor(width / vm.blockSize);
        vm.canvas.width = vm.blockSize * 27;
        vm.canvas.height = vm.blockSize * 7;
        vm.createString();
        vm.createOffScreenCanvas();
        vm.startTimer();
        if (vm.clock_mode) {
          vm.create_clock_canvas(vm.getTime());
        }
      }
    },

    restartSettings() {
      let vm = this;
      // maybe make this a function as it get repeated alot
      store
        .getItem("last_message_user_string")
        .then(last_message_user_string => {
          if (last_message_user_string !== null) {
            vm.user_string = last_message_user_string;
          }
        });

      store.getItem("last_message_color").then(last_message_color => {
        if (last_message_color !== null) {
          vm.circleStyle.fillStyle = last_message_color;
        }
      });
    },

    applySettings() {
      // store.setItem("settings-ratio", Number(this.minutesRatio));
    },

    copyLink() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text"); //
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        console.log(successful);
        alert("Link copied to clipboard");
      } catch (err) {
        alert("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },

    contact() {
      window.location.href = "mailto:ledmulti@dunks1980.com";
    },
    privacy() {
      window.location.href = "/privacy";
    },
    cookie() {
      window.location.href = "/cookie-policy";
    },
    googleLink() {
      window.open("https://www.google.com/search?q=how+to+allow+notifications");
    },

    startTimer() {
      if (this.running_animation) {
        requestInterval.clear(this.running_animation);
      }
      let vm = this;

      vm.running_animation = requestInterval(80, function() {
        if (!vm.clock_mode) {
          if (vm.offset + vm.offscreen_canvas.width <= 0) {
            vm.offset = 0;
          }
          vm.offset -= vm.blockSize;
          vm.drawCanvas(vm.offset);
        } else {
          vm.offset = 0;
          vm.drawCanvas_clock();
        }
      });
    },

    getNotificationPermissions() {
      let vm = this;

      Notify.requestPermission(onPermissionGranted, onPermissionDenied);

      function onPermissionGranted() {
        console.log("Permission has been granted by the user");
        vm.doNotification = true;
        //store.setItem("doNotification", true);
        vm.doNotification_blocked = false;
      }

      function onPermissionDenied() {
        console.warn("Permission has been denied by the user");
        vm.doNotification = false;
        //store.setItem("doNotification", false);
        vm.doNotification_blocked = true;
      }
    },

    stopTimer() {
      this.worker.postMessage({ time: null });
    },

    fullScreen() {
      let doc = window.document;
      let docEl = doc.documentElement;
      let requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      let cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;
      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
        this.noSleep.enable(); // keep the screen on!
        this.wakeLockEnabled = true;
        document.getElementById('cookie_munch_element').setAttribute('style', 'display: none;');
      } else {
        cancelFullScreen.call(doc);
        this.noSleep.disable(); // let the screen turn off.
        this.wakeLockEnabled = false;
        document.getElementById('cookie_munch_element').setAttribute('style', '');
      }
      
    },

    Notification_test(msg) {
      function fireNotification() {
        navigator.serviceWorker.ready.then(function(registration) {
          registration.showNotification("LED multi", {
            body: msg,
            notifyShow: onNotifyShow
          });
        });
      }
      navigator.serviceWorker.register("js/sw.js");
      this.getNotificationPermissions();
      if (this.doNotification) {
        fireNotification();
        this.doNotification_blocked = false;
      } else {
        this.doNotification_blocked = true;
      }
      function onNotifyShow() {
        //console.log("notification was shown!");
      }
    },
    Notification_show(msg) {
      function fireNotification() {
        navigator.serviceWorker.ready.then(function(registration) {
          registration.showNotification("LED multi", {
            body: msg,
            notifyShow: onNotifyShow // callback
          });
        });
      }

      navigator.serviceWorker.register("js/sw.js");

      this.getNotificationPermissions();

      if (this.doNotification) {
        fireNotification();
        //this.doNotification_blocked = false;
      } else {
        //this.doNotification_blocked = true;
      }
      function onNotifyShow() {
        //console.log("notification was shown!");
      }
    }
  },
  created() {
    //this.restartSettings();

    let vm = this;
    let installPrompt;
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      installPrompt = e;
    });
    this.installer = () => {
      installPrompt.prompt();
      installPrompt.userChoice.then(result => {
        if (result.outcome === "accepted") {
          console.log("user accepted");
          vm.pwaAccepted = true;
          //store.setItem("pwaAccepted", true);
        } else {
          console.log("user denied");
        }
        installPrompt = null;
      });
    };

    /////////////////////////////////
    // get query params

    let uri = window.location.href.split("?");
    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";
      vars.forEach(function(v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });

      // do
      console.log("query params");
      console.log(getVars);
      if (getVars["text"]) {
        getVars["text"] = getVars["text"].substring(
          3,
          getVars["text"].length - 3
        );
        getVars["text"] = getVars["text"]
          .replace(/%20/g, " ")
          .replace(/%22/g, '"');

        vm.user_string = getVars["text"];
      }
      
      if (getVars["color"]) {
        vm.circleStyle.fillStyle = getVars["color"];
      }
      if (getVars["clock_mode"]) {
        console.log("getting clock mode param")
        
        if (getVars["clock_mode"] === "false") {
          vm.clock_mode = false;
        } else {
          vm.clock_mode = true;
        }
      }
    } else {
      store
        .getItem("last_message_user_string")
        .then(last_message_user_string => {
          if (last_message_user_string !== null) {
            vm.user_string = last_message_user_string;
          }
        });
      store.getItem("last_message_color").then(last_message_color => {
        if (last_message_color !== null) {
          vm.circleStyle.fillStyle = last_message_color;
        }
      });
      store.getItem("clock_mode").then(clock_mode => {
        if (clock_mode !== null) {
          vm.clock_mode = clock_mode;
        }
      });
    }
    window.history.replaceState({}, document.title, "/");
     

    /////////////////////////////////



 document.addEventListener('fullscreenchange', exitHandler);
  document.addEventListener('webkitfullscreenchange', exitHandler);
document.addEventListener('mozfullscreenchange', exitHandler);
document.addEventListener('MSFullscreenChange', exitHandler);


function exitHandler() {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        ///fire your event
    
      vm.wakeLockEnabled = false;
    
    } else {
 
      vm.wakeLockEnabled = true;

    } 
  }



}}
</script>


